import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight, faCheckCircle, faHandHoldingHeart, faStar } from '@fortawesome/free-solid-svg-icons';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ResizeService } from '../../services/resize.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    CarouselModule,
    LazyLoadImageModule,
    RouterModule,
    FontAwesomeModule,
  ],
  providers: [ResizeService],
  selector: 'app-expert-carousel-profile',
  templateUrl: './expertCarousel.component.html',
  styleUrls: ['./expertCarousel.component.scss'],
})
export class ExpertCarouselComponentProfile implements OnInit {
  faStar = faStar;
  faArrowLeft = faArrowRight;
  faCheckCircle=faCheckCircle
  faHandHoldingHeart=faHandHoldingHeart
  @Input() experts: any;
  @Input() loading: boolean;
  
  ngOnInit() {    
  }
}
